import React from 'react'
import { Trades } from '@paramount-prestart/shared'

export const TradeBadges = ({ trades }) =>
  trades?.map((t) => (
    <span key={t} className="trade-badge">
      {Trades.tradeLabel(t)}
    </span>
  ))
